import React from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { primaryColor } from "../../../Constants/Colors";
import { GoArrowUpRight } from "react-icons/go";
import missionImg from "../../../Assets/Images/AboutUs/Rectangle.png";
import visionImg from "../../../Assets/Images/AboutUs/Vision.png";
import WorksMarquee from "./WorksMarquee/WorksMarquee";
import Timeline from "./Timeline";
import teamImg from "../../../Assets/Images/AboutUs/Team.png";

const AboutUs = () => {
  const missions = [
    {
      id: 1,
      title: "Simplified Digital Solutions",
    },
    {
      id: 2,
      title: "Scalable & Smart Tech Integration",
    },
    {
      id: 3,
      title: "Results-Driven Execution",
    },
  ];
  const visions = [
    {
      id: 1,
      title: "Human-Centered Design Focus",
    },
    {
      id: 2,
      title: "Long-Term Digital Sustainability",
    },
    {
      id: 3,
      title: "Continuous Innovation & Growth",
    },
  ];

  return (
    <>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
           
            className="m-auto d-flex flex-column justify-content-center"
          >
            <div
              style={{
                textAlign: "center",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#009dff",
                  border: "none",
                  boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
                }}
                className="rounded-pill my-2 px-4"
              >
                About Us
              </Button>

              <h1
                className="my-3"
                style={{ color: "#009dff", fontWeight: "bold" }}
              >
                Shaping The Future Of Digital Experiences
              </h1>

              <p className="text-muted mb-4">
                At Ideal Corporate Services, we empower brands with innovative
                digital solutions — from custom web development and UI/UX design
                to scalable software systems. Our mission is to help businesses
                grow smarter, perform better, and stay ahead in a rapidly
                evolving digital world.
              </p>

              <Button
                style={{
                  background: "linear-gradient(to right, #007bff, #00bfff)",
                  border: "none",
                  color: "white",
                  boxShadow: "0 4px 20px rgba(0, 157, 255, 0.3)",
                }}
                className="rounded-pill px-4 py-2"
              >
                Discover Our Services <GoArrowUpRight size={18} />
              </Button>
            </div>
          </Col>
        </Row>

        <Row className="m-auto my-5">
          <Col
            xs={12}
            md={11}
            lg={10}
            className="m-auto d-flex flex-column justify-content-center"
          >
            <div className="text-center">
              <h1 style={{ color: primaryColor }}>
                Empowering Digital Growth, One Solution at a Time
              </h1>
              <p className="text-muted">
                We empower businesses to scale and succeed by crafting clean,
                strategic, and technology-driven digital solutions. Whether it’s
                UI/UX design, custom platforms, or complete transformation—our
                expert team ensures your brand is user-focused, high-performing,
                and future-ready.
              </p>
            </div>
          </Col>
        </Row>
        <WorksMarquee />
        <Row className="">
          <Col xs={12} md={7} lg={7} xl={6} className="px-3 px-lg-5 my-5">
            <Button
              className="rounded-pill"
              style={{ backgroundColor: primaryColor, border: "none" }}
            >
              Mission
            </Button>
            <h6 className="fw-bold my-3" style={{ color: primaryColor }}>
              Turning Complex Ideas Into Clear, Scalable Digital Solutions
            </h6>
            <p className="text-muted text-justify">
              At Ideal, we’re not just delivering services—we’re building
              digital partnerships. Our mission is to simplify technology for
              businesses by offering solutions that are intuitive, impactful,
              and results-driven. We blend creative strategy with intelligent
              systems to help our clients lead with clarity.
            </p>
            <ul className="list-unstyled">
              {missions.map((mission, index) => {
                return (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      borderLeft: `5px solid ${primaryColor}`,
                      borderRight: "5px solid rgb(201, 203, 204)",

                      borderRadius: "10px",
                      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
                    }}
                    className="p-1 p-lg-2 mt-2 mt-lg-3 mx-4"
                  >
                    <span
                      className="pe-3"
                      style={{
                        background:
                          "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                        WebkitMaskImage:
                          "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskSize: "cover",
                        display: "inline-block",
                        width: "20px",
                        height: "20px",
                      }}
                    ></span>
                    {mission.title}
                  </li>
                );
              })}
            </ul>
          </Col>
          <Col xs={12} md={5} lg={5} xl={4} className="m-auto">
            <Image src={missionImg} fluid />
          </Col>
        </Row>

        <Row className="my-5">
          <Col xs={12} md={5} lg={5} xl={4} className="m-auto d-none d-md-flex">
            <Image src={visionImg} fluid />
          </Col>
          <Col xs={12} md={7} lg={7} xl={6} className="px-3 px-lg-5">
            <Button
              className="rounded-pill"
              style={{ backgroundColor: primaryColor, border: "none" }}
            >
              Vision
            </Button>
            <h6 className="fw-bold my-3" style={{ color: primaryColor }}>
              To Be the Go-To Digital Partner for Modern Brands
            </h6>
            <p className="text-muted text-justify">
              We envision a digital future where every business, regardless of
              size, can access elegant design and smart technology. Our goal is
              to lead innovation in UI/UX and digital transformation, delivering
              user-first solutions that elevate businesses globally.
            </p>
            <ul className="list-unstyled">
              {visions.map((vision, index) => {
                return (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      borderLeft: `5px solid ${primaryColor}`,
                      borderRight: "5px solid rgb(201, 203, 204)",

                      borderRadius: "10px",
                      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
                    }}
                    className="p-1 p-lg-2 mt-2 mt-lg-3 mx-4"
                  >
                    <span
                      className="pe-3"
                      style={{
                        background:
                          "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                        WebkitMaskImage:
                          "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskSize: "cover",
                        display: "inline-block",
                        width: "20px",
                        height: "20px",
                      }}
                    ></span>
                    {vision.title}
                  </li>
                );
              })}
            </ul>
          </Col>
          <Col xs={12} md={5} lg={5} xl={4} className="m-auto d-flex d-md-none">
            <Image src={visionImg} fluid />
          </Col>
        </Row>
      </Container>
      <Timeline />
      <Container className="my-5">
        <Row className="">
          <Col xs={12}>
            <Button
              className="rounded-pill"
              style={{ backgroundColor: primaryColor, border: "none" }}
            >
              Team
            </Button>
          </Col>

          <Row className="mt-3">
            <Col xs={12} md={12} lg={5}>
              <h2>Where <span className="text-primary">Passion</span> Meets <br className="d-none d-lg-block"/> <span className="text-primary">Performance</span></h2>
            </Col>

            <Col xs={12} md={12} lg={7} >
              <p className="text-muted text-justify" style={{fontSize:'13px'}}>Our leadership team brings together decades of experience in digital strategy, UI/UX design, and scalable tech development. At Ideal, we believe strong leadership fosters stronger solutions. Each expert on our team plays a key role in shaping future-ready digital experiences that drive real results for our clients.</p>
            </Col>
          </Row>
          <Col xs={12} md={12} className="m-auto mt-4">
          <Image src={teamImg} className="img-fluid"/>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AboutUs;
